import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import storage from './utils/tool';
Vue.use(storage);
// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(echarts)
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js